import { render, staticRenderFns } from "./OutlookIndex.vue?vue&type=template&id=fbb0ebca&scoped=true"
import script from "./OutlookIndex.vue?vue&type=script&lang=js"
export * from "./OutlookIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbb0ebca",
  null
  
)

export default component.exports